import { render, staticRenderFns } from "./self_roll_set.vue?vue&type=template&id=7a3fccd8"
import script from "./self_roll_set.vue?vue&type=script&lang=js"
export * from "./self_roll_set.vue?vue&type=script&lang=js"
import style0 from "./self_roll_set.vue?vue&type=style&index=0&id=7a3fccd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports